/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import {
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
} from "./changePasswordTypes";

const initialState = {
  loading: false,
  succeeded: false,
  resetPassword: {},
  error: "",
};

const resetPasswordReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
        succeeded: false,
      };
    case RESET_PASSWORD_SUCCESS:
      return {
        loading: true,
        succeeded: true,
        resetPassword: action.payload,
        error: "",
      };
    case RESET_PASSWORD_FAILURE:
      return {
        loading: false,
        succeeded: false,
        resetPassword: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

export default resetPasswordReducer;
